export { default } from './PageKioskDevices.vue'
